import { render } from "./사경측경클리닉.vue?vue&type=template&id=4abcbf91"
import script from "./사경측경클리닉.vue?vue&type=script&lang=js"
export * from "./사경측경클리닉.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__